import Vue from 'vue';
import App from './App.vue';
import { router } from './router';
import store from './store';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VeeValidate from 'vee-validate';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faHome,
  faUser,
  faUserPlus,
  faUserTie,
  faRunning,
  faSignInAlt,
  faSignOutAlt,
  faCloudUploadAlt,
  faPeopleArrows,
  faPersonBooth,
  faCalendarPlus
} from '@fortawesome/free-solid-svg-icons';
import RolePlugin from './my-role-plugin';
import MyComputed from './myComputed';
// import CompetitionPlugin from './my-competition-plugin';
import http from './http-common';


// import Moment from 'moment';

// Moment.locale('nb');
// Object.definePrototype(Vue.prototype, '$moment', { value: moment });
// Vue.prototype.$moment = Moment;
library.add(faHome, faUser, faUserPlus, faUserTie, faRunning, faSignInAlt, faSignOutAlt, faCloudUploadAlt, faPeopleArrows, faPersonBooth, faCalendarPlus);

Vue.config.productionTip = false;

Vue.use(RolePlugin);
Vue.use(MyComputed);
// Vue.use(CompetitionPlugin);

Vue.use(VeeValidate);
Vue.use(require('vue-moment'));
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.prototype.$api = http;

new Vue({
  router,
  store,
  render: h => h(App),
	beforeCreate() {
    this.$store.commit('initialiseStore');

    // Subscribe to store updates
    this.$store.subscribe((mutation, state) => {
      // Store the state object as a JSON string
      // console.log("subscribe:"+ state.auth.selectedCompetition);
      // console.log("subscribe");
      // console.log(mutation);
      // console.log(state);
      localStorage.setItem('store', JSON.stringify(state));
      // if ( state && state.competition ) {
      //   localStorage.setItem('store_competition', JSON.stringify(state.competition));
      // }
    });
  }
}).$mount('#app');

